module.exports = __webpack_public_path__ + "assets/img/5_1190.0abde7d3.jpg";